import { render, staticRenderFns } from "./domain-switch.vue?vue&type=template&id=7d74eb95"
import script from "./domain-switch.vue?vue&type=script&lang=js"
export * from "./domain-switch.vue?vue&type=script&lang=js"
import style0 from "./domain-switch.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports